import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import ROUTES from '~/shared/constants/routes.const'
import loginAnalytics from '~/analytics/login/loginAnalytics'
import appConfig from '~/config/app'
import { ButtonPrimary } from '~/components/Buttons/ButtonPrimary'

export function RecoverPasswordButton(): React.ReactElement | null {
  const router = useRouter()
  const { t } = useTranslation('authenticate')

  const handleOnClickForgetPassword = (): void => {
    loginAnalytics.logButtonClick('forget_password')
    router.push(ROUTES.RESET_PASSWORD)
  }

  // No self-service password reset on the school platform. Pre-auth surface, so there is no role to
  // gate on — this hides the link for school teachers and admins too.
  if (appConfig.isSchoolPlatform) return null

  return (
    <div className="h-full space-y-4 flex flex-col items-center justify-start">
      <div className="h-px w-full bg-black-light" />
      <span>{t('authenticate:resetPasswordPreText')} </span>

      <ButtonPrimary onClick={handleOnClickForgetPassword} size="small" type="reset">
        {t('authenticate:resetPasswordBtnText')}
      </ButtonPrimary>
    </div>
  )
}
